export class PackageSelector {
    constructor(options = {}) {
        this.calculatorEl = document.querySelector('.calculator');
        this.popupEl = document.querySelector('.package-popup');

        // If there's no calculator but there is a popup, run in info-only mode
        if (!this.calculatorEl) {
            if (this.popupEl) {
                this.initInfoOnly();
            }
            return;
        }

        this.basePriceInput = this.calculatorEl.querySelector('input[name="baseprice"]');
        this.packageRadios = this.calculatorEl.querySelectorAll('input[name="package"]');
        this.packagePriceEl = this.calculatorEl.querySelector('.calculator__package-price');
        this.packageNameEl = this.calculatorEl.querySelector('.calculator__package-name');
        this.totalEl = this.calculatorEl.querySelector('.calculator__total');

        this.init();
    }

    initInfoOnly() {
        this.bindPopupToggle();
    }

    init() {
        this.bindPackageSelection();
        this.bindPopupToggle();
        this.bindPopupPackageButtons();
        this.bindTooltips();
    }

    bindPackageSelection() {
        this.packageRadios.forEach(radio => {
            radio.addEventListener('change', (e) => {
                this.updatePrice(e.target.value, e.target.dataset.name);
                this.updateSelectedState(e.target);
            });
        });
    }

    bindPopupToggle() {
        const toggleBtns = document.querySelectorAll('[data-package-popup-toggle]');
        toggleBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.openPopup();
            });
        });

        if (this.popupEl) {
            const closeBtns = this.popupEl.querySelectorAll('[data-popup-close]');
            closeBtns.forEach(btn => {
                btn.addEventListener('click', () => this.closePopup());
            });
        }
    }

    bindPopupPackageButtons() {
        if (!this.popupEl) return;

        const packageButtons = this.popupEl.querySelectorAll('[data-select-package]');
        packageButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const packageKey = btn.dataset.selectPackage;
                this.selectPackage(packageKey);
            });
        });
    }

    bindTooltips() {
        // Tooltips are handled via CSS :hover, no JS needed
    }

    updatePrice(packagePrice, packageName) {
        if (!this.basePriceInput) return;

        const basePrice = parseInt(this.basePriceInput.value, 10) || 0;
        const additionalPrice = parseInt(packagePrice, 10) || 0;
        const totalPrice = basePrice + additionalPrice;

        if (this.totalEl) {
            this.totalEl.textContent = '\u20AC ' + this.formatNumber(totalPrice) + ',-';
        }

        if (this.packagePriceEl) {
            this.packagePriceEl.textContent = '\u20AC ' + this.formatNumber(additionalPrice) + ',-';
        }

        if (this.packageNameEl && packageName) {
            this.packageNameEl.textContent = packageName.toUpperCase();
        }
    }

    updateSelectedState(selectedRadio) {
        this.packageRadios.forEach(radio => {
            const label = radio.closest('.calculator__package');
            if (label) {
                label.classList.remove('calculator__package--selected');
            }
        });

        const selectedLabel = selectedRadio.closest('.calculator__package');
        if (selectedLabel) {
            selectedLabel.classList.add('calculator__package--selected');
        }
    }

    selectPackage(packageKey) {
        const radio = this.calculatorEl.querySelector(`input[name="package"][data-key="${packageKey}"]`);
        if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change'));
        }
        this.updatePopupButtons(packageKey);
        this.closePopup();
    }

    openPopup() {
        if (this.popupEl) {
            // Update button states before showing popup (only when calculator exists)
            if (this.calculatorEl) {
                const selectedRadio = this.calculatorEl.querySelector('input[name="package"]:checked');
                if (selectedRadio) {
                    this.updatePopupButtons(selectedRadio.dataset.key);
                }
            }
            this.popupEl.style.display = 'flex';
            document.body.style.overflow = 'hidden';
        }
    }

    updatePopupButtons(selectedKey) {
        if (!this.popupEl) return;

        const packageButtons = this.popupEl.querySelectorAll('[data-select-package]');
        packageButtons.forEach(btn => {
            const packageKey = btn.dataset.selectPackage;
            const column = btn.closest('.package-popup__column');

            if (packageKey === selectedKey) {
                btn.disabled = true;
                btn.textContent = 'GEKOZEN';
                btn.classList.add('package-popup__select-btn--selected');
                if (column) {
                    column.classList.add('package-popup__column--selected');
                }
            } else {
                btn.disabled = false;
                btn.textContent = 'KIES DIT PAKKET';
                btn.classList.remove('package-popup__select-btn--selected');
                if (column) {
                    column.classList.remove('package-popup__column--selected');
                }
            }
        });
    }

    closePopup() {
        if (this.popupEl) {
            this.popupEl.style.display = 'none';
            document.body.style.overflow = '';
        }
    }

    formatNumber(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
}
